

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import Sprite = PIXI.Sprite;
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {HarlequinGameConfig} from "../../HarlequinGameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {HarlequinGameModuleConfig} from "../../HarlequinGameModuleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";

export class HarlequinSignView extends BaseView {

    private _layer:ScalableLayer;

    private _leftSign:Sprite;
    private _rightSign:Sprite;

    private _barPortrait:Sprite;
    private _headSpine:PIXI.spine.Spine;


    private _textSpine:PIXI.spine.Spine;
    private _textSpriteWrapper:PIXI.Sprite;

    private _leftSpine:PIXI.spine.Spine;
    private _rightSpine:PIXI.spine.Spine;

    private _topTl:Timeline | null;
    private _textTl:Timeline | null;
    private _headTl:Timeline | null;

    private _enterNrOfRespins:number | null;


    // TODO: OBSOLETE
    private _topBarAnimNames:string [] = [

        // respin text
        "HarlequinRespin-1",
        "HarlequinRespin-2",
        "HarlequinRespin-3",
        "HarlequinRespin-4",
        "HarlequinRespinTextBasgane",
        "HarlequinRespinTextOn",

        // base game heads
        "HeadActive1",
        "HeadActive2",
        "HeadActive3",

        // top bar
        "baseGamaeToBonusGameWon",
        "baseGameToRespin",
        "bonusGameFirstScatter",
        "bonusGameSecundScatter",
        "respinBonusWonToBonusgame",
        "respinToBaseGame",
        "respinToBonusGameWon",
        "bonusGameThirdScatter",
        "bonusGameWonToBonusGame"
    ];


    // TODO: ALL OBOSLETE!? ///////////////////////
    private _baseGameHeadAnimations:string [] = [
        "HeadActive1",
        "HeadActive2",
        "HeadActive3"
    ];

    private _respinTextAnimations:string [] = [
        "HarlequinRespin-0",
        "HarlequinRespin-1",
        "HarlequinRespin-2",
        "HarlequinRespin-3",
        "HarlequinRespin-4",
        //"HarlequinRespinTextBaseGame",
        "HarlequinRespinTextOn"
    ];

    private _topBarAnimations:string [] = [
        "baseGamaeToBonusGameWon",
        "HeadActive1",
        "HeadActive2",
        "HeadActive3",
        "bonusGameFirstScatter",
        "bonusGameSecundScatter",
        "baseGameToRespin",
        "bonusGameThirdScatter",
        "bonusGameWonToBonusGame",
        "respinBonusWonToBonusgame",
        "respinToBaseGame",
        "respinToBonusGameWon"
    ];
    // TODO: /////////////////////////////////////

    // TODO: NEW STRUCTURE
    private _leftBarAnims:string [] = [
        "NewBaseGameDefault",
        "NewBaseGameToRespin",
        "NewRespinDefault"
    ];
    private _middleBarAnims:string [] = [
        "New1headDefault",
        "New3HeadsDefault",
        "New1headTo3Heads",
        "NewFirstScatterDefault",
        "NewFirstScatterLanding",
        "NewSecundScatterDefault",
        "NewSecundScatterLanding",
        "NewThirdScatterDefault",
        "NewThirdScatterLanding",
        "New3ScattersReset"
    ];
    private _rightBarAnims:string [] = [
        "New3HeadsBonusGameTextDefault",
        "New3HeadsBonusGameTextToBonusWonText",
        "New1HeadBonusGametextTo3HeadsBonusgameText",
        "NewBonusGameDefaultToBonusgameActivatingHarlequinDrop2",
        "NewBonusHarlequinSignAppersBonusHarlequin Teese",
        "NewBonusHarlequindenTextDefault",
        "NewBonusWonToBonusgameActivatingHarlequinDrop",
        "Newo3headsBonusWonTextDefault",
        "resetBaseGame",
        "New1HeadBonusGametTextDefaultBasgamePortrait"
    ];

    private _leftBar:Sprite;
    private _middleBar:Sprite;
    private _rightBar:Sprite;

    private _leftBarSpine:PIXI.spine.Spine;
    private _middleBarSpine:PIXI.spine.Spine;
    private _rightBarSpine:PIXI.spine.Spine;

    private _leftBarTimeline:Timeline | null;
    private _middleBarTimeline:Timeline | null;
    private _rightBarTimeline:Timeline | null;

    // TODO: //////////////////////////////////////
    private _triggered:boolean = false;
    private _orientation:string;
    private _currentRightAnim:string = "";

    private _baseGameHeads: {
        left: {
            active:boolean
        },
        middle: {
            active:boolean
        },
        right: {
            active:boolean
        }
    } = {
        left : {
            active : false
        },
        middle : {
            active : false
        },
        right : {
            active : false
        }
    };
    private _headsLocked:boolean = false;

    private _respinNumberNames: string [] = [
        "respinNumber1",
        "respinNumber2",
        "respinNumber3",
        "respinNumber4"
    ];
    private _respinNumberWrapper:PIXI.Sprite = new PIXI.Sprite();

    private tmpDebugHandler():void {
        const ref = this;
        let cntr:number = 0;
        let headCntr:number = 0;

        let leftCntr:number = 0;
        let middleCntr:number = 0;
        let rightCntr:number = 0;
        let textCntr:number = 0;

        document.addEventListener("keydown", function(e) {
            var keyCode = e.keyCode;
            //console.log("KeyCode: " + keyCode);

            switch(keyCode) {
                case 48:
                    ref.resetSign();
                    cntr = 0;
                    headCntr = 0;
                    textCntr = 0;
                    //ref.visible = false;
                    break; // 0

                case 54:

                    // Left bar animations
                    // Left bar animations
                    let tstr:string = "";
                    let tcount:number = textCntr;

                    if(textCntr === 5) {
                        tcount = textCntr = 0;
                    }

                    if(textCntr > -1 && textCntr < 5) {
                        tcount = textCntr++;
                        ref.playTextNr(tcount);
                    }

                    console.log("PLAYING RESPIN TEXT: " + tstr + ", COUNT: " + tcount);
                    break; // 6
                case 55:
                    let lstr:string = "";
                    let lcount:number = leftCntr;

                    if(leftCntr === ref._leftBarAnims.length) {
                        lcount = leftCntr = 0;
                    }

                    if(leftCntr > -1 && leftCntr < ref._leftBarAnims.length) {
                        lcount = leftCntr++;
                        ref.playLeftBar(lstr = ref._leftBarAnims[lcount], 0);
                    }


                    console.log("PLAYING LEFT BAR: " + lstr + ", COUNT: " + lcount);
                    break; // 7

                case 56:

                    // Middle bar animations
                    let mstr:string = "";
                    let mcount:number = middleCntr;

                    if(middleCntr === ref._middleBarAnims.length) {
                        mcount = middleCntr = 0;
                    }

                    if(middleCntr > -1 && middleCntr < ref._middleBarAnims.length) {
                        mcount = middleCntr++;
                        ref.playMiddleBar(mstr = ref._middleBarAnims[mcount], 0);
                    }


                    console.log("PLAYING MIDDLE BAR: " + mstr + ", COUNT: " + mcount);
                    break; // 8

                case 57:

                    // Right Bar Animations
                    let rstr:string = "";
                    let rcount:number = rightCntr;

                    if(rightCntr === ref._rightBarAnims.length) {
                        rcount = rightCntr = 0;
                    }

                    if(rightCntr > -1 && rightCntr < ref._rightBarAnims.length) {
                        rcount = rightCntr++;
                        ref.playRightBar(rstr = ref._rightBarAnims[rcount], 0);
                    }


                    console.log("PLAYING RIGHT BAR: " + rstr + ", COUNT: " + rcount);
                    break; // 9
            }
        }, false);
    }

    public playLeftBar(name:string = "", /*type:number,*/ track:number = 0, loop:boolean = false, onComplete?:(trackEntry:PIXI.spine.core.TrackEntry) => void, respinNumber:number = 0):Timeline {
        const tl:Timeline = new TimelineLite();
        //debugger;

        tl.add(() => {
            if(this._leftBarAnims.indexOf(name) > -1) {
                    this._leftBarSpine.state.setAnimation(track, name, loop);

                    if(name === "NewBaseGameDefault") {
                        this.playTextNr(-1, true);
                    }
            }
        });
        tl.add(() =>  {}, "+=0.2");
        if(onComplete) {
            // Add callback to listener
            this._leftBarSpine.state.addListener({
                    //event: function(entry, event) { console.log('event fired '+event.data+' at track' + entry.trackIndex) },
                    end: (entry:PIXI.spine.core.TrackEntry) => {
                        onComplete(entry);
                    }
                    //start: function(entry) { console.log('animation is set at '+entry.trackIndex) },
                    //end: function(entry) { console.log('animation was ended at '+entry.trackIndex) }
            });
        }

        this._leftBarTimeline = tl;

        return tl;
    }

    public playMiddleBar(name:string = "", /*type:number,*/ track:number = 0, loop:boolean = false, onComplete?:(trackEntry:PIXI.spine.core.TrackEntry) => void, respinNumber:number = 0):Timeline {
        const tl:Timeline = new TimelineLite();

        tl.add(() => {
            if(this._middleBarAnims.indexOf(name) > -1) {
                this._middleBarSpine.state.setAnimation(track, name, loop);
            }
        });
        tl.add(() =>  {}, "+=0.2");

        if(onComplete) {
            // Add callback to listener
            this._middleBarSpine.state.addListener({
                    //event: function(entry, event) { console.log('event fired '+event.data+' at track' + entry.trackIndex) },
                    complete: (entry:PIXI.spine.core.TrackEntry) => {
                        onComplete(entry);
                    }
                    //start: function(entry) { console.log('animation is set at '+entry.trackIndex) },
                    //end: function(entry) { console.log('animation was ended at '+entry.trackIndex) }
            });
        }

        this._middleBarTimeline = tl;

        return tl;
    }

    public playRightBar(name:string = "", /*type:number,*/ track:number = 0, loop:boolean = false, onComplete?:(trackEntry:PIXI.spine.core.TrackEntry) => void, respinNumber:number = 0):Timeline {
        const tl:Timeline = new TimelineLite();

        if(name ==="resetBaseGame") {
            tl.add(() => {
                if(this._orientation && this._orientation === Orientation.LANDSCAPE) {
                    this._rightBarSpine.state.setEmptyAnimation(0, 0);
                    this._currentRightAnim = "resetBaseGame"
                }
                else {
                    //"New1HeadBonusGametTextDefaultBasgamePortrait"
                    this._rightBarSpine.state.setAnimation(track, "New1HeadBonusGametTextDefaultBasgamePortrait", loop);
                    this._currentRightAnim = "New1HeadBonusGametTextDefaultBasgamePortrait";
                }
            });
        }
        else {
            this._currentRightAnim = "";
            tl.add(() => {
                if (this._rightBarAnims.indexOf(name) > -1) {
                    this._rightBarSpine.state.setAnimation(track, name, loop);
                    if(name === "NewBonusGameDefaultToBonusgameActivatingHarlequinDrop2" || name === "NewBonusWonToBonusgameActivatingHarlequinDrop") {
                        SlotGame.sound.playEffect(HarlequinSoundConfig.instance.WILD_FLAP);
                    }
                }
            });
            tl.add(() =>  {}, "+=0.2");
        }
        if(onComplete) {
            // Add callback to listener
            this._rightBarSpine.state.addListener({
                    //event: function(entry, event) { console.log('event fired '+event.data+' at track' + entry.trackIndex) },
                    end: (entry:PIXI.spine.core.TrackEntry) => {
                        onComplete(entry);
                    }
                    //start: function(entry) { console.log('animation is set at '+entry.trackIndex) },
                    //end: function(entry) { console.log('animation was ended at '+entry.trackIndex) }
            });
        }

        this._rightBarTimeline = tl;

        return tl;
    }

    public resetTopSpine():Timeline {
        const tl:Timeline = new TimelineLite();

        tl.add(() => {
            if(this._topTl) {
                this._topTl.pause();
                this._topTl.kill();
                this._topTl = null;
            }
            this.resetHeadSpine();
        });

        return tl;
    }

    public resetTextSpine():Timeline {
        const tl:Timeline = new TimelineLite();

        tl.add(() => {
            if(this._textTl) {
                this._textTl.pause();
                this._textTl.kill();
                this._textTl = null;
            }

            this.playTextNr(-1, true);
        });

        return tl;
    }

    public resetHeadSpine():Timeline {
        const tl:Timeline = new TimelineLite();

        tl.add(() => {
            if(this._headTl) {
                this._headTl.pause();
                this._headTl.kill();
                this._headTl = null;
            }
        });
        this._headSpine.state.setEmptyAnimation(0, 0);

        this._baseGameHeads.left.active = false;
        this._baseGameHeads.middle.active = false;
        this._baseGameHeads.right.active = false;
        this._headsLocked = false;

        return tl;
    }

    public resetSign():void {
        this.resetTopSpine();
        this.resetTextSpine();
        this.resetHeadSpine();
    }

    public enterMode(fromMode:string, toMode:string, wildDropFirst:boolean = false, restore:boolean = false, triggeringFsSpin:boolean = false, wildDrop:boolean = false):Timeline {
        const tl:Timeline = new TimelineLite();
        //debugger;


        if(wildDrop) {
            tl.add(() => {
                this.playLeftBar("NewRespinDefault", 0, false);
                this.playRightBar("NewBonusHarlequindenTextDefault", 0, false);
            });
        }
        else if ((fromMode === "FREESPIN" || fromMode === "WILD_RESPIN") && toMode === "NORMAL") {
            tl.add(() => {
                //debugger;
                this.playLeftBar("NewBaseGameDefault", 0, false);
                this.playMiddleBar("New1headDefault", 0, false);
                this.playRightBar("resetBaseGame", 0, false);
            });
        }
        else if (fromMode === "NORMAL" && toMode === "FREESPIN") {
            if(restore) {
                //tl.add(() => {
                    if(triggeringFsSpin) {
                        this.playMiddleBar("NewThirdScatterDefault");
                    }
                    else {
                        this.playMiddleBar("New3HeadsDefault")
                    }
                    this.playRightBar("New3HeadsBonusGameTextToBonusWonText");
                    /*if(restore && toMode === "FREESPIN") {
                        this.playLeftBar("NewBaseGameDefault");
                    }*/
                //});
            }
            else {
                tl.add(() => {
                    this.playRightBar("NewBonusHarlequindenTextDefault", 0, false);
                });
            }
        }
        else if(fromMode === "WILD_RESPIN_FS" && toMode === "NORMAL") {
            tl.add(() => {
                this.playLeftBar("NewBaseGameDefault", 0, false);
                this.playMiddleBar("New1headDefault", 0, false);
                this.playRightBar("resetBaseGame", 0, false);
            });
        }
        else if(fromMode === "WILD_RESPIN_FS" && (toMode === "FREESPIN" || toMode === "WILD_RESPIN_FS")) {
            tl.add(() => {
                if(!restore || wildDropFirst || toMode === "FREESPIN") {
                    this.playLeftBar("NewBaseGameDefault", 0, false);
                }
                else {
                    this.playLeftBar("NewRespinDefault", 0, false);
                }
                // this.playMiddleBar("New3HeadsDefault", 0, false); // TODO: Breaking collectors, have separate restore
                this.playRightBar("NewBonusHarlequindenTextDefault", 0, false);
            });
        }
        else if ((fromMode === "NORMAL" || fromMode === "WILD_RESPIN") && toMode === "WILD_RESPIN") {
            tl.add(() => {
                //this.playMiddleBar("New3HeadsDefault", 0, false);
                this.playRightBar("New3HeadsBonusGameTextDefault", 0, false);
            });
        }
        else if ((fromMode === "FREESPIN" || fromMode === "WILD_RESPIN_FS") && toMode === "WILD_RESPIN_FS") {
            //debugger;
            tl.add(() => {
                //this.playMiddleBar("New3HeadsDefault", 0, false); // TODO: Breaking collectors, have separate restore
                this.playRightBar("NewBonusHarlequindenTextDefault", 0, false);
            })
        }

        tl.add(() => {}, "+=0.2");

        console.log("SIGN ENTER MODE FROM: " + fromMode + ", TO MODE: " + toMode);

        return tl;
    }

    public resetPerGameMode(gameMode:string, fullSet:boolean = false, restore:boolean = false):Timeline {
        const tl:Timeline = new TimelineLite();


        if(restore) {

        }
        else {
            if (gameMode === "NORMAL") {
                tl.add(() => {
                    this.playLeftBar("NewBaseGameDefault", 0, false);
                    this.playMiddleBar("New1headDefault", 0, false);
                    this.playRightBar("resetToBaseGame", 0, false);
                });
            } else if (gameMode === "FREESPIN") {
                tl.add(() => {
                    this.playLeftBar("NewBaseGameDefault", 0, false);
                    this.playMiddleBar("New3ScattersReset", 0, false);
                    this.playRightBar("New3HeadsBonusGameTextDefault", 0, false);
                })
            } else if (gameMode === "WILD_RESPIN") {
                tl.add(() => {
                    this.playLeftBar("NewRespinDefault", 0, false);
                    this.playMiddleBar("New3HeadsDefault", 0, false);
                    this.playRightBar("New3HeadsBonusGameTextDefault", 0, false);
                })
            } else if (gameMode === "WILD_RESPIN_FS") {
                tl.add(() => {
                    this.playLeftBar("NewRespinDefault", 0, false);
                    this.playMiddleBar("New3HeadsDefault", 0, false);
                    this.playRightBar("New3HeadsBonusGameTextDefault", 0, false);
                })
            }
        }

        return tl;
    }

    public playTextSpine(name:string = "", respinLeft:number = 0, track:number = 0, loop:boolean = false, onComplete?:(trackEntry:PIXI.spine.core.TrackEntry) => void, respinTriggered:boolean = false):Timeline {
        const tl: TimelineLite = new TimelineLite();
        let animName:string = name;

        //if(headCount && headCount >= 0) {
            //debugger;
            tl.add(() => {
                    this.playTextNr(respinLeft);
            });

        this._textTl = tl;

        return tl;
    }

    public litNextHead():Timeline {
        const tl = new TimelineLite();
        const names: string [] = [
            "HeadActive1",
            "HeadActive2",
            "HeadActive3"
        ];

        //debugger;
        if(!this._headsLocked) {
            if (!this._baseGameHeads.left.active) {
                tl.add(() => {
                   this.playHeadSpine(undefined, 0, true);
                    //HarlequinGameModuleConfig.harlequinSignView.litNextHead();
                });
            }
            else if (!this._baseGameHeads.middle.active) {
                tl.add(() => {
                    this.playHeadSpine(undefined, 1, true);
                    //this.updateIndicator(names[1], true);
                });
            }
            else if (!this._baseGameHeads.right.active) {
                tl.add(() => {
                    this.playHeadSpine(undefined, 2, true, undefined, undefined, undefined, true);
                    //this.playRightBar("New3HeadsBonusGameTextToBonusWonText", 0, false);
                    //this.updateIndicator(names[2], true);
                });
                //tl.add(() => {
                //this.resetIndicators(); // TODO: get called from wild drop?
                //}, "+=0.35");
            }
            else {
                //this.resetIndicators();
                // TODO: make reset behavior more nice
                tl.add(() => {
                    //this.updateIndicator(0, true);
                });
            }
        }

        return tl;
    }

    public playHeadSpine(name?:string, headCount?:number, activity:boolean = true, track:number = 0, loop:boolean = false, onComplete?:(trackEntry:PIXI.spine.core.TrackEntry) => void, mainGame:boolean = false):Timeline {
        const tl:TimelineLite = new TimelineLite();

        //this._headSpine.setEmptyAnimation(track, 0);

        if(!name) {
            switch(headCount) {
                case 0:
                    this._baseGameHeads.left.active = activity;
                    tl.add(() => {
                        SlotGame.sound.playEffect(HarlequinSoundConfig.instance.SCATTER_COLLECT);
                        this.playMiddleBar("NewFirstScatterLanding", 0, false);
                    }, "+=0.2");
                    break;
                case 1:
                    this._baseGameHeads.middle.active = activity;
                    tl.add(() => {
                        SlotGame.sound.playEffect(HarlequinSoundConfig.instance.SCATTER_COLLECT);
                        this.playMiddleBar("NewSecundScatterLanding", 0, false);
                    }, "+=0.2");
                    break;
                case 2:this._baseGameHeads.right.active = activity;
                    tl.add(() => {
                        SlotGame.sound.playEffect(HarlequinSoundConfig.instance.SCATTER_COLLECT);
                        this.playMiddleBar("NewThirdScatterLanding", 0, false, (mainGame)? () => {} : (entry: PIXI.spine.core.TrackEntry) => {
                            //if (entry.animation.name == "NewThirdScatterLanding") {
                            //}
                        });
                        new TimelineLite().add(this.playRightBar("New3HeadsBonusGameTextToBonusWonText", 0, false), 0.4);
                    }, "+=0.2");
                    break;
            }
        }
        else {
            tl.add(() => {
                if (name && this._baseGameHeadAnimations.indexOf(name) > -1) {
                    this._headSpine.state.setAnimation(track, name, loop);
                }
            });
        }

        if(onComplete) {
            // Add callback to listener
            tl.add(
                () => this._headSpine.state.addListener({
                    //event: function(entry, event) { console.log('event fired '+event.data+' at track' + entry.trackIndex) },
                    complete: (entry:PIXI.spine.core.TrackEntry) => {
                        onComplete(entry);
                    }
                    //start: function(entry) { console.log('animation is set at '+entry.trackIndex) },
                    //end: function(entry) { console.log('animation was ended at '+entry.trackIndex) }
                })
            );
        }

        this._headTl = tl;

        return tl;
    }

    public playSignSpine(name:string = "", /*type:number,*/ track:number = 0, loop:boolean = false, onComplete?:(trackEntry:PIXI.spine.core.TrackEntry) => void, respinNumber:number = 0, restore:boolean = false):Timeline {
        const tl:Timeline = new TimelineLite();
        tl.add(() => {
            if(this._topBarAnimations.indexOf(name) > -1) {
                if(["baseGameToRespin", "respinToBaseGame", "respinToBonusGameWon"].indexOf(name) > -1) {
                    //this._topBarPortraitSpine.state.setAnimation(track, name, loop);

                    if(name === "baseGameToRespin" && respinNumber >= 0) {
                        // TODO: play respin splash number
                        if(restore) {
                             this.playLeftBar("NewRespinDefault", 0, false);
                        }
                        else {
                            this.playRespinNumber(respinNumber);
                            this.playLeftBar("NewBaseGameToRespin");
                        }

                    }
                }

            }
        });

        this._topTl = tl;

        return tl;
    }

    constructor() {
        super();

        this._layer = StageManager.getLayer(HarlequinGameConfig.instance.LAYERS.SIGNS.name);
        this._layer.addChild(this);
    }

    initAnimations() {
        // TODO: Remove left and right signs
        this._leftSign = new Sprite();
        this._leftSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("signRespin"));
        this._leftSign.anchor.set(0.5, 0.5);
        this._leftSign.x = 365;
        this._leftSign.y = 67;
        this._leftSign.scale.set(0.9, 0.9);
        //this._leftSign.addChild(this._leftSpine);

        this._rightSign = new Sprite();
        this._rightSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("signBonus"));
        this._rightSign.anchor.set(0.5, 0.5);
        this._rightSign.x = 865;
        this._rightSign.y = 67;
        this._rightSign.scale.set(0.9, 0.9);
        this._rightSign.addChild(this._rightSpine);
        ////////

        this._barPortrait = this.createPortraitBar();

        //this.tmpDebugHandler();

        this.createBarSpines();

        this.addChild(this._barPortrait);

        this.createNumbers();
        this.createRespinNumber();

        this.playRightBar("resetBaseGame");
    }

    protected createNumbers():void {
        this._textSpriteWrapper = new PIXI.Sprite();
        this._textSpriteWrapper.scale.set(0.315, 0.315);

        [0,1,2,3,4].forEach((value) => {
            const sprite:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("textNr" + value)[0]);
            sprite.name = "textNr" + value;
            sprite.anchor.set(0.5, 0.5);
            sprite.visible = false;
            this._textSpriteWrapper.addChild(sprite);
        });

        this.addChild(this._textSpriteWrapper);
    }

    playTextNr(value:number, reset:boolean = false):void {
        this._textSpriteWrapper.children.forEach((sprite) => {
            sprite.visible = false;
        });
        if(!reset && value >= 0 && value <= 4) {
            this._textSpriteWrapper.getChildByName("textNr"+value)!.visible = true;
        }
    }

    protected createBarSpines():void {
        this._leftBar = new Sprite();
        this._leftBarSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("leftBar"));
        this._leftBar.anchor.set(0.5, 0.5);
        this._leftBar.x = 365;
        this._leftBar.y = 67;
        this._leftBar.scale.set(0.9, 0.9);

        this._middleBar = new Sprite();
        this._middleBarSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("middleBar"));
        this._middleBar.position.y = 180;
        this._middleBar.position.x = 640;


        this._rightBar = new Sprite();
        this._rightBarSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("rightBar"));
        this._rightBar.anchor.set(0.5, 0.5);
        this._rightBar.x = 865;
        this._rightBar.y = 67;
        this._rightBar.scale.set(0.9, 0.9);

        this.addChild(this._leftBarSpine);
        this.addChild(this._middleBarSpine);
        this.addChild(this._rightBarSpine);

    }

    // TODO: The old top bar creation
    protected createPortraitBar():Sprite {
        const sprite:Sprite = new Sprite();
        this._headSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("baseGameHeads"));
        return sprite;
    }


    protected createRespinNumber():void {
        this._respinNumberWrapper.anchor.set(0.5, 0.5);
        this._respinNumberNames.forEach((name:string, index) => {
            const sprite = new PIXI.Sprite(GameResources.getTextures(name)[0]);
            sprite.name = "" + index;
            sprite.visible = false;
            this._respinNumberWrapper.addChild(sprite);
        });

        this.addChild(this._respinNumberWrapper);
    }

    protected playRespinNumber(numberId:number):Timeline {
        const tl: Timeline = new TimelineLite();
        let animSprite: PIXI.Sprite | null = null;

        this._respinNumberWrapper.children.forEach((sprite) => {
            const spr = <PIXI.Sprite>sprite;

            spr.visible = false;
            if (spr.name === "" + numberId) {
                spr.alpha = 0;
                spr.visible = true;
                animSprite = spr;
            }
        });

        if (animSprite) {
            tl.add(TweenLite.to(animSprite, 0.8, {alpha: 1}));
            tl.add(TweenLite.to(animSprite, 0.4, {alpha: 0}), "+=0.4");
            tl.add(() => {
                if (animSprite) {
                    animSprite.visible = false;
                }
            })
        }


        return tl;
    }

    onResize(data:IResizeData) {
        this.x = -280;
        this._orientation = data.orientation;

        if(data.orientation === Orientation.PORTRAIT) {
            this.y = -178.5;

            this._textSpriteWrapper.position.set(298, 205);

            this._leftSign.x = 356;
            this._leftSign.y = 180;
            this._leftSign.scale.set(1.1, 1.1);

            this._rightSign.x = 890;
            this._rightSign.y = 183;
            this._rightSign.scale.set(1.1, 1.1);

            this._headSpine.scale.set(0.66, 0.66);
            this._headSpine.position.y = 200;
            this._headSpine.position.x = 720;

            this._respinNumberWrapper.position.set(576, 345);

            // New structure
            this._leftBarSpine.scale.set(1, 1);
            this._leftBarSpine.position.y = 180;
            this._leftBarSpine.position.x = 640;

            this._middleBarSpine.scale.set(1, 1);
            this._middleBarSpine.position.y = 180;
            this._middleBarSpine.position.x = 640;

            this._rightBarSpine.scale.set(1, 1);
            this._rightBarSpine.position.y = 180;
            this._rightBarSpine.position.x = 645;
        }
        else {
            this.y = -228.5;

            this._textSpriteWrapper.position.set(315, 375);
            this._leftSign.x = 365;
            this._leftSign.y = 282;
            this._leftSign.scale.set(1, 1);

            this._rightSign.x = 880;
            this._rightSign.y = 285;
            this._rightSign.scale.set(1, 1);

            this._headSpine.scale.set(0.57, 0.57);
            this._headSpine.position.y = 365;
            this._headSpine.position.x = 697.5;

            this._respinNumberWrapper.position.set(567, 485);

            // New structure
            this._leftBarSpine.scale.set(0.92, 0.92);
            this._leftBarSpine.position.y = 352;
            this._leftBarSpine.position.x = 630;

            this._rightBarSpine.scale.set(0.92, 0.92);
            this._rightBarSpine.position.y = 352;
            this._rightBarSpine.position.x = 620;

            this._middleBarSpine.scale.set(0.92, 0.92);
            this._middleBarSpine.position.y = 352;//365;
            this._middleBarSpine.position.x = 630;//697.5;
        }

        if(this._currentRightAnim !== "") {
            this.playRightBar("resetBaseGame");
        }

    }

    protected activate() {

        this._leftSpine.state.setAnimation(0, "idle", false);
        this._rightSpine.state.setAnimation(0, "bonusSignIdle", false)
    }

    public get triggered():boolean {
        return this._triggered;
    }

    public set triggered(bool:boolean) {
        this._triggered = bool;
    }


    public setRespinSignAnimation(value:number = 0, respinTriggered:boolean = false):Timeline {

        // TODO: This is left sign"!
        const tl:Timeline = this.playTextSpine("", value, undefined, undefined, undefined, respinTriggered);
        return tl;
    }

    public setBonusSignAnimation(name:string, onComplete: () => void = () => {}, loop:boolean = false):Timeline {
        const tl:TimelineLite = new TimelineLite();

        tl.add([
            () => this._rightSpine.state.setAnimation(0, name, loop),
            (name === "bonusSignTurningActive" && !this._triggered)? () => {
                this._triggered = true;
                HarlequinGameModuleConfig.harlequinScatterCollectorView.lock();
            } : () => {}
        ]);

        return tl;
    }

}